import React from 'react';

import EyeCloseIcon from '@images/eye-close.svg';
import { EyeOpenIcon } from '@images/eye-open.svg';
import { LockIcon } from '@images/lock.svg';

import './DocumentAccess.scss';

const DocumentAccess = props => {
    if (!props.access || props.access === 'all') {
        return <EyeOpenIcon />;
    }

    if (props.access === 'owner') {
        return <EyeCloseIcon />;
    }

    if (props.access === 'users') {
        return (
            <div className='users-access-container'>
                <div className='users-access-counter'>
                    <LockIcon /> {props.access_users_count}
                </div>
                <EyeOpenIcon />
            </div>
        );
    }
};

export default DocumentAccess;
